import { render, staticRenderFns } from "./ShortDescriptionMediumSize.vue?vue&type=template&id=6ffa8ac6&"
import script from "./ShortDescriptionMediumSize.vue?vue&type=script&lang=js&"
export * from "./ShortDescriptionMediumSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports